<template>
    <Address v-model="address_id" />
    <div class="shipping__method">
        <div class="shipping__method__header">
            <span class="shipping__method__header__title">نحوه ارسال</span>
        </div>
        <template v-if="address_id">
            <ShippingMethod
                v-for="method in shippingMethods"
                :method="method"
                v-model:shippingMethod="shipping_method"
                v-model:shippingPeriod="shipping_period_id"
            />
        </template>
        <template v-else>
            <div class="alert alert-info mb-0">برای انتخاب شیوه و زمان ارسال ابتدا آدرس خود را وارد کنید.</div>
        </template>
        <div class="shipping__method__footer">
            <a :href="route('shopping-cart')"><span class="icon-Chevron_right"></span>بازگشت به سبد خرید</a>
        </div>
    </div>
</template>

<script>
import Address from "./Address";
import ShippingMethod from "./ShippingMethod";

export default {
    name: "Shipping",
    components: {ShippingMethod, Address},
    props: ["addressId" , "shippingMethod", "shippingPeriodId", "shippingMethods"],
    emits: ["update:addressId", "update:shippingMethod", "update:shippingPeriodId"],
    data: () => ({
        shipping_methods: [],
        loading: false,
        address_id: null,
        shipping_method: null,
        shipping_period_id: null,
    }),
    watch: {
        address_id() {
            this.$emit("update:addressId", this.address_id);
        },
        shipping_method() {
            this.$emit("update:shippingMethod", this.shipping_method);
        },
        shipping_period_id() {
            this.$emit("update:shippingPeriodId", this.shipping_period_id);
        },
    },
}
</script>

<style scoped>

</style>
